import React from 'react';
import { DataList, CustomModal } from 'commons-ui';

import useDashboardActions from 'pages/dashboard/useDashboardActions';
import { LIST_ENTITY_NAMES } from 'constant';

import useService from '../../../utils/useService';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import { PAGE_DETAILS, columnConfigs } from './listConfig';

const ListReferralSegmentPolicies: React.FC<{}> = () => {
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList);
	const actions = getActionList();

	const { requestGetReferralSegmentPolicies } = useService();

	return (
		<>
			<CustomModal />
			<DataList
				fetchData={requestGetReferralSegmentPolicies}
				columnConfigs={columnConfigs}
				getActionHandler={getActionHandler}
				actions={actions}
				rowHeight={150}
				defaults={PAGE_DETAILS}
				entity={LIST_ENTITY_NAMES.REFERRAL}
				initialSortDirection='ASC'
				initialSortIndex={0}
			/>
		</>
	);
};

export default ListReferralSegmentPolicies;
